export const INFORMATION = {
  avatar:
    "https://res.cloudinary.com/dgq6qxh4k/image/upload/v1689696148/Lima_oedmeh.png",
  banner:
    "https://res.cloudinary.com/dgq6qxh4k/image/upload/f_auto,q_auto/nidkmuerru7c1ufeocxi",
  title: "Lima Boutique",
  description: "",
  phone: "5493404438300",
  sheet:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vTFSTGq5k-XYrrAwbVPMD0mpmhgnF2jYokO47AnjJj89AAKswBM02npFFdvKSD09aHa3GQD97QExwyd/pub?output=csv",
  color: "teal",
  social: [
    {
      url: "https://www.instagram.com/_lima.boutique__/",
      name: "instagram",
    },
    {
      url: "https://wa.me/5493404438300",
      name: "whatsapp",
    },
  ],
};
